import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import { passValidationErrors, generatePassword } from 'utils/functions';
import { resetPassword } from 'Settings/Security/SecFunctions';
import { detectClientIP } from 'utils/functions';

const useStyles = makeStyles(theme => ({}));

function ResetPassword(props) {
  const classes = useStyles();
  const { newUserData } = props;
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState(false);
  const disabled = Boolean(error || !password || password !== confirmPassword);
  const confirmPassErr = password === confirmPassword ? false : "Passwords don't match";

  useEffect(() => {
    const validationErrors = passValidationErrors('', password);
    if (password && validationErrors.length) {
      setError(validationErrors[0]);
    } else {
      if (error) setError(false);
    }
    // eslint-disable-next-line
  }, [password]);

  const renderEnterPassword = () => {
    return (
      <div className={classes.formWrap} style={{ marginTop: 10 }}>
        <TextField
          required
          variant="outlined"
          label="Enter Password"
          fullWidth
          placeholder="Enter Password"
          type="password"
          value={password}
          onChange={(ev, val) => setPassword(ev.target.value)}
          size="small"
          error={error}
          helperText={error}
          autoComplete="new-password"
          InputProps={{
            className: classes.input,
            autoComplete: 'new-password',
          }}
        />
      </div>
    );
  };
  const renderConfirmPassword = () => {
    return (
      <div className={classes.formWrap} style={{ marginTop: 10 }}>
        <TextField
          required
          variant="outlined"
          label="Confirm Password"
          fullWidth
          placeholder="Confirm Password"
          type="password"
          value={confirmPassword}
          onChange={(ev, val) => setConfirmPassword(ev.target.value)}
          size="small"
          error={confirmPassErr}
          helperText={confirmPassErr}
          InputProps={{
            className: classes.input,
          }}
        />
      </div>
    );
  };

  const createNewPassword = async finalPassword => {
    const user = {
      userName: newUserData.userName,
      email: newUserData.email,
      password: finalPassword,
    };
    try {
      const userIP = await detectClientIP();

      const data = await resetPassword(userIP, user);
      props.notify('Password updated and email sent to the user.', 'success');

      setPassword('');
      setConfirmPassword('');
    } catch (err) {
      props.notify(err.errors && err.errors.length > 0 ? err.errors[0] : err.message, 'error');
    }
  };

  const changePassword = async (sendRandomPassword = false) => {
    if (!window.confirm('Reset password and email to user?')) return;
    if (sendRandomPassword) createNewPassword(generatePassword());
    else await createNewPassword(password);
  };

  return (
    <>
      <div style={{ textAlign: 'center' }}>
        <div style={{ marginTop: -10, marginBottom: 10, fontSize: '16px' }}>
          Use Random Password
        </div>
        <Button
          color="primary"
          variant="contained"
          autoFocus
          disabled={!newUserData.email}
          onClick={() => changePassword(true)}>
          Create and Send
        </Button>
      </div>
      <div style={{ marginTop: 20, textAlign: 'center' }}>
        <div style={{ fontSize: '16px' }}>OR Enter Password</div>
        {renderEnterPassword()}
        {renderConfirmPassword()}
        <Button
          style={{ marginTop: 10 }}
          color="primary"
          variant="contained"
          autoFocus
          disabled={!newUserData.email || disabled}
          onClick={() => changePassword()}>
          Change Password
        </Button>
      </div>
    </>
  );
}
export default ResetPassword;